import {
  ClaiCollection,
  ClaiField,
  type ClaiFieldReference,
} from '@clai/schema';

export function getCollectionFields(
  schemaFields: ClaiField[],
  collection: ClaiCollection
): ClaiField[] {
  const references: ClaiFieldReference[] = [];

  if (collection.type === 'pdf') {
    references.push(...collection.fields);
  }
  if (collection.type === 'form' || collection.type === 'doc') {
    references.push(...collection.pages.flatMap(page => page.fields));
  }

  const fieldById = new Map(schemaFields.map(f => [f.id, f]));

  const resolved: ClaiField[] = [];
  for (const ref of references) {
    const field = fieldById.get(ref.fieldId);
    if (field) {
      resolved.push(field);
    }
  }

  return resolved;
}
